/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUrlaubsantragDto } from '../../models/create-urlaubsantrag-dto';
import { UrlaubsantragDto } from '../../models/urlaubsantrag-dto';

export interface CreateUrlaubsantrag$Plain$Params {
      body?: CreateUrlaubsantragDto
}

export function createUrlaubsantrag$Plain(http: HttpClient, rootUrl: string, params?: CreateUrlaubsantrag$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
  const rb = new RequestBuilder(rootUrl, createUrlaubsantrag$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlaubsantragDto>;
    })
  );
}

createUrlaubsantrag$Plain.PATH = '/v1/urlaubsantraege';
